import { Tabs, useTabState, Panel } from '@bumaga/tabs';
import PageVisibility from 'react-page-visibility';

import useInterval from '@use-it/interval';

import React, { useContext, useEffect, useState, useRef } from 'react';

import _ from "lodash";

import L from 'leaflet';

import dynamic from 'next/dynamic';

import { Map, Polyline, GeoJSON, Marker } from 'react-leaflet';

import { distanceTo } from 'geolocation-utils';

import LocationContext from '../../context/location-context';
// import PostContext from '../../context/post-context';
// import * as gpsData from '../../data/gps.json';
import { PARAM_SENSOR_FIELD, CONDITION_MAPPING } from '../../utils/constants';
import { fetchLocationsByBounds, fetchGpsJson, fetchLastLocation } from '../../utils/fetchUtils';
import { default as europe } from '../../data/geojson/europe.json';

import './MapPanel.css';
import './tabs.css';

import MapLayers from './layers/MapLayers';
import MapMarkers from './markers/MapMarkers';
import { createClusterCustomIcon } from './markers/cluster-poi/ClusterPoi';
const MarkerClusterGroup = dynamic(import('react-leaflet-markercluster'), { ssr: false })

const userOptions = [
  { value: 'prod', label: 'prod' },
  { value: 'Wojtek', label: 'Wojtek' },
  { value: 'Aleksandra', label: 'Aleksandra' },
  { value: 'Tomasz', label: 'Tomasz' },
  { value: 'Przemek', label: 'Przemek' },
  { value: 'Dareczek', label: 'Dareczek' },
  { value: 'Olga', label: 'Olga' },
  { value: 'Monika', label: 'Monika' },
  { value: 'test1', label: 'test1' },
  { value: 'test2', label: 'test2' },
  { value: 'test3', label: 'test3' },
];

const cn = (...args) => args.filter(Boolean).join(' ')

const Tab = ({ children }) => {
  const { isActive, onClick } = useTabState()

  return (
    <button className={cn('tab', isActive && 'active')} onClick={onClick}>
      {children}
    </button>
  )
}

function createIcon(poiData) {
  const icon = selectIcon(poiData.info.value);
  return new L.Icon({
    iconUrl: require(`../../assets/images/${icon}`),
    iconRetinaUrl: require(`../../assets/images/${icon}`),
    iconSize: [40, 40],
  })
}

function selectIcon(item) {
  switch (item) {
    case 'RELAY_CHANGE':
      return 'relay-change.svg';
    case 'RR_TRACK':
      return 'rnr.svg';
    case 'ACCOMMODATION':
      return 'accomodation.svg';
    case 'FOOD':
      return 'foodie.svg';
    case 'VIEW':
      return 'view.svg';
    case 'RELAX':
      return 'relax.svg';
    case 'MONUMENT':
      return 'monument.svg';
    case 'BEACH':
      return 'beach.svg';
    case 'SERVICE_STATION':
      return 'service-station.svg';
    case 'CLIMB':
      return 'mountain.svg';
    case 'COFFEE':
      return 'coffee.svg';
    case 'TEMPLE':
      return 'church.svg';
    case 'MARKET':
      return 'market.svg';
    case 'WEATHER':
      return 'weather.svg';
    default:
      return 'placeholder.svg';
  }
}

function degToCard(deg) {
  if (deg > 11.25 && deg < 33.75) {
    return "NNE";
  } else if (deg > 33.75 && deg < 56.25) {
    return "ENE";
  } else if (deg > 56.25 && deg < 78.75) {
    return "E";
  } else if (deg > 78.75 && deg < 101.25) {
    return "ESE";
  } else if (deg > 101.25 && deg < 123.75) {
    return "ESE";
  } else if (deg > 123.75 && deg < 146.25) {
    return "SE";
  } else if (deg > 146.25 && deg < 168.75) {
    return "SSE";
  } else if (deg > 168.75 && deg < 191.25) {
    return "S";
  } else if (deg > 191.25 && deg < 213.75) {
    return "SSW";
  } else if (deg > 213.75 && deg < 236.25) {
    return "SW";
  } else if (deg > 236.25 && deg < 258.75) {
    return "WSW";
  } else if (deg > 258.75 && deg < 281.25) {
    return "W";
  } else if (deg > 281.25 && deg < 303.75) {
    return "WNW";
  } else if (deg > 303.75 && deg < 326.25) {
    return "NW";
  } else if (deg > 326.25 && deg < 348.75) {
    return "NNW";
  } else {
    return "N";
  }
}

function preparePoints(data) {
  let points = [];
  for (const point of data) {
    if (point.e_pos_lat && point.e_pos_long) {
      let isPoi = false;
      if (point.params && point.params.length > 0) {
        for (const ep of point.params) {
          if (ep.e_param_class === 'POI') {
            isPoi = true;
            continue; 
          }
        }
      }
      if (!isPoi) {
        points.push([point.e_pos_lat, point.e_pos_long]);
      }
    } else {
      points.push([point.e_pos_lat, point.e_pos_long]);
    }
  }
  return points;
}


function generateMarkerPoints(poIPoints, setPoints) {
  const points = preparePoints(poIPoints);
  setPoints(points);
}
const startFinishIcon = new L.Icon({
  iconUrl: require('../../assets/images/red-dot.svg'),
  iconRetinaUrl: require('../../assets/images/red-dot.svg'),
  iconSize: [50, 50],
  className: 'start-finish-icon'
})

const currentPositionIcon = new L.Icon({
  iconUrl: require('../../assets/images/bike.svg'),
  iconRetinaUrl: require('../../assets/images/bike.svg'),
  iconSize: [40, 40],
  className: 'current-location-icon'
})
const MapPanel = (props, state) => {
  const { locations, dispatchLocations } = useContext(LocationContext);
  // const { posts, dispatchPosts } = useContext(PostContext);
  const [isGpsReq, setIsGpsReq] = useState(false);
  const [isActiveTab, setIsActiveTab] = useState(true);
  const [markers, setMarkers] = useState();
  const [points, setPoints] = useState();
  const [user, setUser] = useState({ value: 'prod', label: 'prod' });
  const [centerPosition, setCenterPosition] = useState([47.319832054, 5.038166514]);
  const refreshAction = () => {
    if(isActiveTab){
      //fetchLocationsByBounds(dispatchLocations, zoomLevel, mapRef.current.leafletElement.getBounds(), user.value);
      fetchLastLocation(dispatchLocations);
      if(!isGpsReq){
        fetchGpsJson(dispatchLocations);
        setIsGpsReq(true);
      }
    }
  };
  let lastRoutPoint = [52.2305, 21.00694];
  const data = locations.locations;
  let startPoint = [52.2305, 21.00694];
  let finishPoint = [22.95217, -16.15861];

  if (points) {
    const length = points.length;
    const value = points[length - 1];
    if (value) {
      lastRoutPoint = [value[0], value[1]];
    }
  }
  const [zoom, setZoom] = useState(5);
  const mapRef = useRef(null);
  const zoomLevel = 0;

  useInterval(refreshAction, 600000);
  useEffect(refreshAction, [dispatchLocations]);
  useEffect(() => {
    if (locations && locations.locations && locations.locations.length > 0) {
      generateMarkerPoints(locations.locations, setPoints);
      const length = locations.locations.length;
      const value = locations.locations[length - 1];
      setCenterPosition([value.e_pos_lat, value.e_pos_long]);
    }
  }, [locations]);

  const stages = locations && locations.gps ? locations.gps : [];

  let distance = 0;
  let minDistance = 0;
  let minIdx = 0;
  stages.forEach((item, idx) => {
    distance = distanceTo(item, lastRoutPoint);
    if (minDistance === 0) {
      minDistance = distance;
      minIdx = idx;
    } else if (distance < minDistance) {
      minDistance = distance;
      minIdx = idx;
    }
  });
  
  let stagesNoPassed = stages.slice(minIdx);
  const stagesPassed = stages.slice(0, minIdx);
  // Adding last point to connect passed route and planned route
  stagesNoPassed.unshift(lastRoutPoint);
  const CustomStyle = {
    control: base => ({
      ...base,
      boxShadow: "none",
      ':hover': {
        border: 'none'
      }
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: 'white',
      color: 'black',
      zIndex: 999,
      width: '100px',
      ':active': {
        backgroundColor: '#ECDADF',
        width: "100%",
      },
      ':hover': {
        backgroundColor: '#ECDADF',
        width: "100%",
      },
    })
  }
  return (
    <React.Fragment>
      <div className="oracle-logo">
        <img src={require("../../assets/images/oracle.svg")} alt="" />
      </div>

      <div className="map-wrapper">
        <Map
          key={centerPosition[0]}
          ref={mapRef}
          maxZoom="25"
          zoom={zoom}
          center={centerPosition}
          onZoomEnd={evt => setZoom(evt.sourceTarget.getZoom())}>          
          {points && points.length > 0 && <Marker position={points[points.length - 1]} icon={currentPositionIcon}></Marker>}
          <MapMarkers zoom={zoom}></MapMarkers>
            <span>
              <Marker position={startPoint} icon={startFinishIcon}></Marker>
              <Marker position={finishPoint} icon={startFinishIcon}></Marker>
            </span>
          <Polyline color="#ec1d25" weight="4" opacity="0.2" positions={stagesNoPassed} />
          {stagesPassed && stagesPassed.length > 0 && <Polyline color="#ec1d25" weight="3" opacity="1" positions={stagesPassed} />}
          <GeoJSON data={europe} style={{ color: '#ec1d25', fill: false, weight: 2 }} />
          <MapLayers center={centerPosition} />
        </Map>        
      </div >
      <PageVisibility>
            { isVisible =>  {
              if(isActiveTab !== isVisible){
                setIsActiveTab(isVisible);
              }
              return <span></span>;
            }
            }
        </PageVisibility>
    </React.Fragment>
  )
}

export { MapPanel as default }